module.exports = __webpack_public_path__ + "static/img/icon-insurance-07.e467d230.png";